<template>
  <!-- https://michalsnik.github.io/aos/ -->
  <v-container>
    <v-card class="mx-auto" max-width="550">
    <v-system-bar    color="pink darken-2" dark></v-system-bar>

    <v-app-bar color="#424242" dark dense>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>My files</v-toolbar-title>
    </v-app-bar>



      <v-expand-transition>
      <v-card  color="#385F73"  dark  height="90">
        
        <v-row  dense>  
          <v-col  cols="12" class="ma-0 pa-0" >
                              <v-spacer></v-spacer>
               <v-card-text>
                <p class="ma-0 pa-0 text-h6 text-center" >30 second exercises. 5 x day.</p>
                <p class="ma-0 pa-0 text-h6 text-center">Stretch and move throughout the day</p>
      
              </v-card-text>
          </v-col>
        </v-row>

        </v-card>    
        </v-expand-transition>

      <v-card  color="#1F7087"  dark>
        

        <v-row  dense class="text-center" color="#1F7087"  dark>  
          <v-col  cols="12">
            <!-- assume 25 minutes target. 1 minute=4% of total -->
            <v-progress-circular :size="300" :width="20" color="rgba(190, 24, 90, 0.6)" :value="totalForToday*4">
                <div class="text-h2 orange--text">{{this.totalForToday}} mins today</div>
             </v-progress-circular>

          </v-col>
        </v-row>


    <div class="text-center">
 <v-btn width="250" class="ma-2 pa-0 text-center" flat color="orange" @click="$router.push('/list')">New Set</v-btn>
    </div>
       
    <div class="text-center">
 <v-btn width="250" class="ma-2 pa-0 text-center" flat color="orange" @click="$router.push('/sets')">Existing Set</v-btn>
    </div>


        </v-card>    



    
  </v-card>



<br/>
<br/>
  </v-container>
</template>

<style>
.v-progress-circular {
margin: 1rem;
}
</style>



<script>
export default {

  name: 'Home',

  data: () => ({
    drawer: false,
    group: null,
    totalForToday: 0
  }),
  watch: {
    group () {
      this.drawer = false
    },
  }, 
  created() {
    this.getSessionTotalForToday();
  },
  methods: {
    getSessionTotalForToday() {
       let totalToday = this.$store.getters.getSessionTotalToday;
       this.totalForToday = totalToday;
      console.log("totalToday: " + totalToday);

    }
  }          
}
</script>
